/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import Enum from './Enum';
//@import Enum (loadtime) // superclass

/**
 * <p>Java class for filterUsageType. <p>The following schema fragment specifies the expected content contained within this class. <p> <pre> &lt;simpleType name="filterUsageType"&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}NMTOKEN"&gt; &lt;enumeration value="Always"/&gt; &lt;enumeration value="ByDefault"/&gt; &lt;enumeration value="Never"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; </pre>
 */
export default class FilterUsageType extends Enum{

	enumValue = null;

	/**
	 * The filter should always be applied to the query.
	 */
	static  ALWAYS = FilterUsageType.newLiteral("Always");

	/**
	 * If a query has a filter that references any of the items of the current filter, then do not apply this filter, but instead use the filter supplied in the query.
	 */
	static  BY_DEFAULT = FilterUsageType.newLiteral("ByDefault");

	/**
	 * Use this setting when a filter should not be applied, handy for testing/development purposes.
	 */
	static  NEVER = FilterUsageType.newLiteral("Never");



	constructor(v) {
		super(v);
		this.enumValue = v;
	}

	static fromValue(v) {
		for (var i = 0; (i < FilterUsageType.values().length); ++i) {
			if (FilterUsageType.values()[i].enumValue == v) {
				return FilterUsageType.values()[i];
			}
		}
		throw new Error(v);
	}

	value() {
		return this.enumValue;
	}

	getResourceId() {
		return (("FilterUsageType" + "_") + this.value());
	}
}


// WEBPACK FOOTER //
// ./src/generated/FilterUsageType.js